<template>
  <div>
    <exo-table :root="_self" disableEditionActions enableImportDeleteActions>
    </exo-table>
    <v-col ref="missionTableErrorDisplay"> </v-col>
  </div>
</template>

<script>
import errorMixin from '../../mixins/logHandler.js'
import fieldsDescription from '../../tools/fieldsDescription.json'
import dataTools from '../../tools/data.js'

import { mapGetters } from 'vuex'

export default {
  name: 'group-import',
  mixins: [errorMixin],

  props: {
    groupId: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },

  mounted() {
    this.refreshTable()
  },

  data: function () {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        { value: 'typeName', text: 'Model', sortable: true },
        { value: 'type', text: 'Type', sortable: true },
        { value: 'description', text: 'Description', sortable: true },
        { value: 'updatedAt', text: 'Share date', sortable: false },
        { value: 'actions', text: 'Actions', sortable: false }
      ],

      tableItems: [],

      inputs: {
        displayForm: false
      }
    }
  },

  methods: {
    async refreshTable() {
      this.tableItems = []
      let self = this
      await this.$http
        .get('/groups/' + this.currentUser.id + '/' + this.groupId)
        .then((response) => {
          this.tableItems = response.data
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of missions shared in the group. ',
            e,
            'notification',
            'error'
          )
        })
    },

    getInfos(item) {
      return dataTools.getInfos(item)
    },

    getCurrentFormAPI(item) {
      return item.typeName + 's'
    },

    getItemAPI(item) {
      return this.getAPI(this.getCurrentFormAPI(item))
    },

    // TODO this method is copied from forms, it should be but in tool file like data.js. Also copied in application layour
    getAPI(objectAPI) {
      return '/users/' + this.currentUser.id + '/' + objectAPI.toLowerCase()
    },

    getCurrentFormTitle() {
      return ''
    },

    getStringFields() {
      return ['displayedName', 'description']
    },

    getValueFields() {
      return []
    },

    getReferenceFields() {
      return []
    },

    getBooleanFields() {
      return []
    },

    getCustomFields() {
      return []
    },

    getDateFields() {
      return ['updatedAt']
    },

    importData(item) {
      let self = this
      this.$http
        .post(
          '/groups/' +
            this.currentUser.id +
            '/' +
            this.groupId +
            '/importfromgroup',
          [item]
        )
        .then(async function () {
          self.displayMessage(
            'Mission successfully imported.',
            '',
            'notification',
            'success'
          )
          self.$root.$emit('update-mission-list')
        })
        .catch((e) => {
          self.displayMessage(
            'Error importing mission ' + e + '. ',
            e,
            'notification',
            'error'
          )
        })
    },

    removeIfNotUsedAsReference: function (item, index, button) {
      let self = this
      let objectName = item.name
      this.$http
        .delete(
          '/groups/' +
            this.currentUser.id +
            '/' +
            this.groupId +
            '/' +
            item.id +
            '/' +
            item.typeName +
            '/deletefromgroup'
        )
        .then(() => {
          self.successAlertDisplayed = true
          self.successAlertMessage = objectName + ' deleted'
          self.refreshTable()
        })
        .catch((e) => {
          self.displayMessage(
            'Error deleting ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
          self.refreshTable()
        })
    },

    async removeAll() {
      for (let item of this.tableItems) {
        this.removeIfNotUsedAsReference(item)
      }
    },

    getEnumProperties: function () {
      return { typeName: {}, type: {} }
    },

    clearForm() {},

    getCurrentFormType() {
      return null
    },

    displayEnumValue(exoData, field) {
      try {
        let desc = fieldsDescription[exoData.typeName]['properties'][field]
        if (exoData[field] && Array.isArray(exoData[field])) {
          return (
            '[' +
            exoData[field]
              .map((el) => desc['values'].find((val) => val.value === el).text)
              .join(', ') +
            ']'
          )
        } else if (exoData[field]) {
          return desc['values'].find((el) => el.value === exoData[field]).text
        }
      } catch (e) {
        return 'undefined'
      }
    }
  }
}
</script>
